import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendContinuousOptimizationLinkCallToAction,
  BackendMutationUpdateContinuousOptimizationLinkCallToActionArgs,
} from 'src/types/backend';

import { FRAGMENT_CO_CONVERSION_GOAL } from './schema';

const MUTATION = gql`
  mutation UpdateCOConversionGoal($id: ID!, $url: String) {
    updateContinuousOptimizationLinkCallToAction(id: $id, url: $url) {
      ...ContinuousOptimizationConversionGoal
    }
  }
  ${FRAGMENT_CO_CONVERSION_GOAL}
`;

type Variables = BackendMutationUpdateContinuousOptimizationLinkCallToActionArgs;
type Result = BackendContinuousOptimizationLinkCallToAction;

export const updateCOConversionGoal = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
